import Repository from "@shared/services/api/abstracts/Repository";
import { AxiosRequestConfig } from "axios";
import { PublicBaseLocationPermissionsV2Serializer } from "../types/seating-types";

export default class PublicBasedTTLocationPermissionsV2Repository extends Repository<PublicBaseLocationPermissionsV2Serializer> {
  public readonly repositoryName =
    "PublicBasedTTLocationPermissionsV2Repository";

  public readonly endpoint =
    "/api/public/events/ticket-types/location-permissions/v2/";

  public async getPermissions(config: AxiosRequestConfig) {
    const { data } = await this.request(this.buildUrl(), config);
    return data;
  }
}
